/*-----------------------------------------------------------------
- Button translations
-----------------------------------------------------------------*/
export default {

    accept   : 'التأكيد',
    cancel   : 'انسحب',
    next     : 'التالي',
    back     : 'سابق',
    finish   : 'نهاية',
    load_more: 'المزيد من المحتوى',
    confirm  : 'التأكيد',

};
